/**
 * Preloads the checkout origin in a hidden 0×0 iframe so the browser
 * has an open connection ready before the user clicks "Pay".
 * Mirrors Stripe's approach: loadStripe() warms up the connection,
 * checkout() swaps the src and makes the frame visible.
 */
export function preloadCheckoutOrigin(checkoutBaseURL: string): HTMLIFrameElement | null {
  if (typeof document === 'undefined' || !document.body) return null;

  const preloadUrl = checkoutBaseURL.replace(/\/$/, '') + '/preload';

  // Dedup per URL — if merchant creates multiple instances with different
  // `checkoutUrl` values, preload each origin (not just the first).
  const existing = document.querySelector(
    `iframe[data-infraio-preload="${cssEscape(preloadUrl)}"]`,
  ) as HTMLIFrameElement | null;
  if (existing) return existing;

  const iframe = document.createElement('iframe');
  iframe.setAttribute('data-infraio-preload', preloadUrl);
  iframe.src = preloadUrl;
  iframe.setAttribute(
    'style',
    'position:absolute;width:0;height:0;border:none;opacity:0;pointer-events:none;',
  );
  iframe.setAttribute('aria-hidden', 'true');
  iframe.setAttribute('tabindex', '-1');
  document.body.appendChild(iframe);
  return iframe;
}

// Polyfill: CSS.escape is widely supported but not in every target.
function cssEscape(s: string): string {
  if (typeof CSS !== 'undefined' && typeof CSS.escape === 'function') {
    return CSS.escape(s);
  }
  return s.replace(/["\\]/g, '\\$&');
}
